import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Check if code is running in browser environment
 * 
 * @param platformId Optional platform ID (will be injected if not provided)
 * @returns true if in browser, false if SSR
 */
export function isBrowser(platformId?: object): boolean {
  const id = platformId ?? inject(PLATFORM_ID);
  return isPlatformBrowser(id);
}

